<template>
  <b-form-group
    :label="$t('tasks.form.targetDate')"
    label-for="target_date"
  >
    <b-input-group>
      <b-form-datepicker
        id="target_date"
        v-model="dataItem.target_date"
        v-bind="datepickerProps"
        :placeholder="$t('fields.selectDate')"
        :min="minDate"
      />
      <template #append>
        <b-button
          variant="warning"
          @click="dataItem.target_date = null"
        >
          <feather-icon icon="XIcon" />
        </b-button>
      </template>
    </b-input-group>
    <small
      v-if="hasDateError"
      class="text-danger"
    >{{ $t('tasks.form.targetBeforeStart') }}</small>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormDatepicker, BButton, BInputGroup,
} from 'bootstrap-vue'
import { datepickerLocale } from '@/libs/i18n/datepicker'

export default {
  name: 'TasksTargetDateCard',
  components: {
    BButton, BFormGroup, BFormDatepicker, BInputGroup,
  },
  mixins: [datepickerLocale],
  computed: {
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isEditMode() {
      return !!this.dataItem.id
    },
    minDate() {
      const start = this.dataItem.start_date || null
      if (this.isEditMode) return start
      const today = new Date().toISOString().split('T')[0]
      if (!start) return today
      return start > today ? start : today
    },
    hasDateError() {
      if (!this.dataItem.start_date || !this.dataItem.target_date) return false
      return new Date(this.dataItem.target_date) < new Date(this.dataItem.start_date)
    },
  },
}
</script>
